<template>
  <div class="page">
    <Header title="员工账号管理"></Header>
    <div class="select-tab">
      <div @click="changeSelectTab('1')" :class="['select-tab-1',userStatus==='1'?'select-tab-active':'']">当前已有员工</div>
      <div @click="changeSelectTab('2')" :class="['select-tab-1',userStatus==='2'?'select-tab-active':'']">已注销员工</div>
    </div>

    <div class="notice-bar" v-if="applyLength!==0">
      <div class="notice-bar-info">提示：您有{{applyLength}}条员工申请消息待处理</div>
      <div class="notice-bar-operation" @click="gotoWeb('staff-apply')">查看</div>
    </div>

    <div class="worker-info" v-if="clientUserList.length!==0">
      <div v-for="(item,index) of clientUserList" @click="gotoWeb('staff-data',item.clientUserId)" class="worker-info-item" :key="index">
        <img :src="getAvatar(item.avatarImageUri)" class="head-portrait"/>
        <div class="worker-info-detail">
          <div class="worker-info-detail-name">{{item.userName}}-{{item.userMobile}}</div>
          <div class="worker-info-detail-point">已获得积分：{{item.pointDTO&&item.pointDTO.pointValue}}</div>
          <div :class="['worker-info-detail-role',item.userRole==='02'?'worker-info-detail-role02':'worker-info-detail-role03']">{{item.userRoleName}}</div>
        </div>
      </div>
    </div>

    <div v-else class="no_data">
      暂无数据
    </div>
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import { commonUtils } from '@/utils/common'
import centerApi from '@/api/center'
export default {
  components: { Header },
  data () {
    return {
      userStatus: '1',
      clientUserList: [],
      approveStatus: '',
      applyLength: 0
    }
  },
  created () {
    this.queryClientUserList()
    this.getApplyLength()
  },
  methods: {
    getAvatar (img) {
      return commonUtils.getImageUrl(img)
    },
    queryClientUserList () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载中'
      })
      let params = {
        userStatus: this.userStatus
      }
      centerApi.queryClientUserList(params).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.clientUserList = res.data.resultData.clientUserList
        }
      })
    },
    getApplyLength () {
      let params = {
        approveStatus: '01'
      }
      centerApi.queryClientUserApplyList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.applyLength = res.data.resultData && res.data.resultData.clientApplyList && res.data.resultData.clientApplyList.length
        }
      })
    },
    gotoWeb (type, clientUserId) {
      if (type === 'staff-data') {
        this.$router.push({ name: 'staff-data', query: { clientUserId } })
      } else if (type === 'staff-apply') {
        this.$router.push({ name: 'staff-apply' })
      }
    },
    changeSelectTab (type) {
      this.userStatus = type
      this.queryClientUserList()
    }
  }

}
</script>

<style lang="less" scoped>
.select-tab{
  background-color: #fff;
  margin: 0 15px;
  width: calc(100% - 30px);
  height: 60px;
  margin-top: 10px;
  border-radius: 5px;
  display: flex;
  justify-content: space-evenly;
  div{
    flex: 1;
    text-align: center;
    margin: 5px;
    line-height: 50px;
  }
  .select-tab-active{
    background-color: rgb(241, 241, 241);
    color: rgb(228, 22, 22);
    border-radius: 5px;
  }
}

.notice-bar{
  display: flex;
  background-color: rgba(255, 0, 0, 0.555);
  padding: 4px 10px;
  color: white;
  margin:15px;
  width: calc(100% - 50px);
  border-radius: 5px;
  justify-content: space-between;
  font-size: 13px;
}
.worker-info{
  margin: 20px  15px 0   15px;
  width: calc(100% - 30px);
}
.worker-info-item{
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 15px;
  height: 80px;
  display: flex;
  .head-portrait{
    margin: 10px;
    border-radius: 5px;
    vertical-align: middle;
  }
  .worker-info-detail{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .worker-info-detail-name{
    width: calc(100vw - 120px);
    font-size: 16px;
    color: black;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .worker-info-detail-point{
    color: grey;
    font-size: 12px;
  }
  .worker-info-detail-role{
    text-align: center;
    font-size: 12px;
    padding: 2px;
    width: 40px;
    border-radius: 5px;
  }
  .worker-info-detail-role03{
    background-color: #e2eef0;
    color: #117181;
  }
  .worker-info-detail-role02{
    background-color: #f8f7db;
    color: #b9b56e;
  }
}
.head-portrait{
  width: 60px;
  height: 60px;
}
.no_data{
  margin-top: 40px;
  text-align: center;
  color: gray;
}
</style>
